import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';

const cache = new InMemoryCache({
  possibleTypes: {
    DynamicZone: [
      'ComponentGeneriqueBlocTextesCoteACote',
      'ComponentGeneriqueDocumentSet',
      'ComponentGeneriqueImage',
      'ComponentGeneriqueImageSansLegende',
      'ComponentGeneriqueImageSet',
      'ComponentGeneriqueImageTexte',
      'ComponentGeneriqueTexte',
      'ComponentGeneriqueTexteSerpents'
    ]
  },
  typePolicies: {
    Query: {
      fields: {
        homePageSagaMicrobiote: {
          merge(existing, incoming, { mergeObjects }) {
            return mergeObjects(existing, incoming);
          }
        }
      }
    },
    PlatDuMidi: {
      keyFields: ['documentId']
    },
    Boisson: {
      keyFields: ['documentId']
    },
    Dessert: {
      keyFields: ['documentId']
    }
  }
});

const authenticatedCmsLink = new HttpLink({
  uri: `${process.env.REACT_APP_BACKEND_URL || '/api'}/graphql`
});

const publicCmsLink = new HttpLink({
  uri: `${process.env.REACT_APP_BACKEND_URL || '/api'}/graphql`
});


const cmsLink = ApolloLink.split((operation) => !!operation.getContext().isPublic, publicCmsLink, authenticatedCmsLink);
const userLink = new HttpLink({
  uri: `${process.env.REACT_APP_USER_URL || '/api'}/user/graphql`,
  credentials: process.env.REACT_APP_DISABLE_CORS ? 'include' : 'same-origin'
});
const link = ApolloLink.split((operation) => !!operation.getContext().isUserQuery, userLink, cmsLink);

export const graphQLClient = new ApolloClient({
  cache,
  link,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all'
    },
    query: {
      errorPolicy: 'all'
    }
  }
});
